module.exports = __webpack_public_path__ + "static/eyemed-individual-54c4f37c200913364d0b56485dbeb762.png";